import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RoutingService } from './../../../home/services/routing.service';
import { isPlatformBrowser } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-channel-not-found',
  templateUrl: './channel-not-found.component.html',
  styleUrls: ['./channel-not-found.component.scss']
})
export class ChannelNotFoundComponent implements OnInit {

  showChannelErrorPage: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.showChannelErrorPage = true;
    }
  }

  navigateHome() {
    this.navigationService.navigateMerchantLanding();
  }
}
